import MirrorPuzzleInfo from './MirrorPuzzleInfo';
export default MirrorPuzzleInfo;
